import { UseFormReturn } from 'react-hook-form'

import { ConvertStablesForm } from '../components/form/ConvertStablesForm'
import { TransactionOverview } from '../components/transaction-overview/TransactionOverview'
import { TxOverview } from '../logic/createTxOverview'
import { ConvertStablesFormSchema } from '../logic/form/schema'
import { ConvertStablesFormFields } from '../types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'

export interface ConvertStablesViewProps {
  formFields: ConvertStablesFormFields
  form: UseFormReturn<ConvertStablesFormSchema>
  txOverview: TxOverview
  actionsViewState: ActionsViewState
}

export function ConvertStablesView({ formFields, form, txOverview, actionsViewState }: ConvertStablesViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Swap Stablecoins</DialogTitle>

      <ConvertStablesForm form={form} formFields={formFields} />

      <TransactionOverview
        txOverview={txOverview}
        inToken={formFields.selectedAssetIn}
        outToken={formFields.selectedAssetOut}
      />

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
